export enum Features {
  FEATURE_FLAG_TEST = 'FEATURE_FLAG_TEST',
  Home_Page = 'Home_Page',
}
